<template>
  <iframe-page
    :src="src"
    :back-link="backLink"
    title="Conservatory"
    @iframe-message="handleMessage"
  >
    <div
      class="custom-content"
    >
      <button @click="handleSkip">
        Skip
      </button>
    </div>
  </iframe-page>
</template>

<script>
import IframePage from './IframePage'

export default {
    name: 'ConservatoryPano',
    components: {
        IframePage
    },
    props: {
      backLink: {
        type: [String, Object, Boolean],
        default: false
      }
    },
    data() {
        return {
            src: process.env.BASE_URL + 'frames/conservatory-360/',
            lastHotspot: false
        }
    },
    methods: {
        handleMessage(event) {
            if (event.data.event == 'go-to-pano') {
              this.$gtm.trackEvent({
                category: 'Pano Reveal',
                action: 'Swipe'
              })
              this.$router.push({name: 'conservatory-explore-pano'})
            }
        },
        handleSkip() {
              this.$gtm.trackEvent({
                category: 'Pano Reveal',
                action: 'Skip'
              })
          this.$router.push({name: 'conservatory-explore-pano' })
        }
    }
}
</script>

<style lang="scss" scoped>
/deep/ .custom-content {
    position: absolute;
    top: 0.5rem;
    right: 0.5rem;
}
</style>
